export default "/images/crm-hover-light.svg?faab42471b520e190387ed43e613487f";